import { render, staticRenderFns } from "./NewChatModal.vue?vue&type=template&id=5a428836&scoped=true&"
import script from "./NewChatModal.vue?vue&type=script&lang=js&"
export * from "./NewChatModal.vue?vue&type=script&lang=js&"
import style0 from "./NewChatModal.vue?vue&type=style&index=0&id=5a428836&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a428836",
  null
  
)

export default component.exports